import SystemEventsPage from './components/SystemEventsPage';

const routes = [
  {
    path: '/system-events',
    name: 'menu.system_events',
    className: 'menu-system-events',
    icon: 'error-list',
    customIcon: true,
    loginRequired: true,
    component: SystemEventsPage,
    weight: 1,
    permission: ['system_events'],
    children: [],
  },
];

export default routes;
